export default __webpack_public_path__ + "static/media/soal-3-left.fef709dc.png";